import {
    SmartSharePaginationQueryParams,
    SmartShareLinkListResponse,
    MainEndpoints,
    UpdateSmartShareLinkBodyParams,
    SmartShareLinkResponse,
    CreateSmartShareLinkBodyParams,
    MessageResponse,
    SmartShareSessionResponse,
    PushSessionBodyParams,
    EmptyResponse,
    SmartShareType,
    SmartShareSessionListResponse,
    SmartShareActivityListResponse
} from "@authory-packages/core";
import axios from "axios";
import { API_URL, withUserSlug } from ".";
import { getHeaders } from "./get-headers";
import { CommonArgs } from "./collections";

export const getSmartShareLinks = async (token: string | null, userSlug: string | undefined, params: SmartSharePaginationQueryParams) => {
    const { data } = await axios.get<SmartShareLinkListResponse>(
        `${API_URL}${withUserSlug(MainEndpoints.UserShareAnalyticsSmartShares, userSlug || "")}`,
        {
            params,
            ...getHeaders(token || "")
        }
    );

    return data;
};

interface updateSmartShareLinkProps extends CommonArgs {
    updatePayload: UpdateSmartShareLinkBodyParams;
    smartShareId: string;
}

export const updateSmartShareLink = async ({ token, userSlug, updatePayload, smartShareId }: updateSmartShareLinkProps) => {
    const res = await axios.post<SmartShareLinkResponse>(
        `${API_URL}${withUserSlug(MainEndpoints.UserShareAnalyticsSmartShareUpdate, userSlug).replace(":smartShareId", smartShareId)}`,
        updatePayload,
        getHeaders(token)
    );

    return res.data;
};

interface createSmartShareLinkProps extends CommonArgs {
    createPayload: CreateSmartShareLinkBodyParams;
}

export const createSmartShareLink = async ({ token, userSlug, createPayload }: createSmartShareLinkProps) => {
    const res = await axios.post<SmartShareLinkResponse>(
        `${API_URL}${withUserSlug(MainEndpoints.UserShareAnalyticsSmartShareCreate, userSlug)}`,
        createPayload,
        getHeaders(token)
    );

    return res.data;
};

interface deleteSmartShareLinkProps extends CommonArgs {
    smartShareId: string;
}

export const deleteSmartShareLink = async ({ token, userSlug, smartShareId }: deleteSmartShareLinkProps) => {
    const res = await axios.post<MessageResponse>(
        `${API_URL}${withUserSlug(MainEndpoints.UserShareAnalyticsSmartShareDelete, userSlug).replace(":smartShareId", smartShareId)}`,
        {},
        getHeaders(token)
    );

    return res.data;
};

interface refreshSmartShareSession {
    userSlug: string;
    smartShareId: string;
    sessionId: string;
}

export const refreshSmartShareSession = async ({ userSlug, smartShareId, sessionId }: refreshSmartShareSession) => {
    const res = await axios.post<SmartShareSessionResponse>(
        `${API_URL}${withUserSlug(MainEndpoints.UserShareAnalyticsSessionRefresh, userSlug).replace(":sessionId", sessionId).replace(":smartShareId", smartShareId)}`
    );

    return res;
};

interface createSmartShareSession {
    userSlug: string;
    smartShareId: string;
}

export const createSmartShareSession = async ({ userSlug, smartShareId }: createSmartShareSession) => {
    const res = await axios.post<SmartShareSessionResponse>(
        `${API_URL}${withUserSlug(MainEndpoints.UserShareAnalyticsSessionCreate, userSlug).replace(":smartShareId", smartShareId)}`
    );

    return res;
};

interface smartShareSessionPushA {
    payload: PushSessionBodyParams;
    userSlug: string;
    smartShareId: string;
    sessionId: string;
}

export const smartShareSessionPush = async ({ userSlug, smartShareId, sessionId, payload }: smartShareSessionPushA) => {
    const res = await axios.post<EmptyResponse>(
        `${API_URL}${withUserSlug(MainEndpoints.UserShareAnalyticsSessionPush, userSlug).replace(":sessionId", sessionId).replace(":smartShareId", smartShareId)}`,
        payload
    );

    return res;
};

export const getSmartShareLink = async (userSlug: string, smartShareURL: string, smartShareUrlType: SmartShareType) => {
    const { data } = await axios.get<SmartShareLinkResponse>(
        `${API_URL}${withUserSlug(MainEndpoints.SmartShareRetrieve, userSlug)
            .replace(":smartShareURL", smartShareURL)
            .replace(":smartShareUrlType", smartShareUrlType)}`
    );

    return data;
};

export const getPrivateSmartShareLink = async (token: string, userSlug: string, smartShareId: string) => {
    const { data } = await axios.get<SmartShareLinkResponse>(
        `${API_URL}${withUserSlug(MainEndpoints.UserShareAnalyticsRetrieve, userSlug).replace(":smartShareId", smartShareId)}`,
        getHeaders(token || "")
    );

    return data;
};

export const getSmartShareLinkSessions = async (token: string, userSlug: string, smartShareId: string, params: SmartSharePaginationQueryParams) => {
    const { data } = await axios.get<SmartShareSessionListResponse>(
        `${API_URL}${withUserSlug(MainEndpoints.UserShareAnalyticsSessions, userSlug).replace(":smartShareId", smartShareId)}`,
        {
            params,
            ...getHeaders(token || "")
        }
    );

    return data;
};

export const getSmartShareLinkSessionActivities = async (
    token: string,
    userSlug: string,
    smartShareId: string,
    sessionId: string,
    params: SmartSharePaginationQueryParams
) => {
    const { data } = await axios.get<SmartShareActivityListResponse>(
        `${API_URL}${withUserSlug(MainEndpoints.UserShareAnalyticsActivities, userSlug).replace(":smartShareId", smartShareId).replace(":sessionId", sessionId)}`,
        {
            params,
            ...getHeaders(token || "")
        }
    );

    return data;
};
